module.exports = __webpack_public_path__ + "img/active-dot.ae9a46cd.svg";